import { useQuery } from "@tanstack/react-query";
import { useStore } from "~/mobx/utils/useStore";

export function useTerms(token: string) {
  const { termsStore } = useStore();

  const query = useQuery({
    queryKey: ["terms", token],
    queryFn: () => {
      return termsStore.readDataForTermsAndConditionsConsent(token);
    },
  });

  return query;
}
